import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, CheckIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-28 bg-gray-50 relative overflow-hidden" data-id="element-36">
      {/* Decorative elements */}
      <div className="absolute top-20 right-0 w-1/3 h-1/3 bg-amber-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-37"></div>
      <div className="absolute bottom-20 left-0 w-1/4 h-1/4 bg-red-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-38"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="text-center mb-20" data-id="element-40">
          <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-600 bg-amber-100 rounded-full mb-4" data-id="element-41">
            Contact Us
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-42">
            Let's Discuss Your Lead Generation Needs
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto" data-id="element-43">
            Fill out the form below to schedule a free consultation with our
            lead generation experts.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-44">
          <div className="lg:col-span-3" data-id="element-45">
            <form className="bg-white p-10 rounded-2xl shadow-xl" data-id="element-46">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8" data-id="element-47">
                <div data-id="element-48">
                  <label htmlFor="first-name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-49">
                    First Name
                  </label>
                  <input type="text" name="first-name" id="first-name" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-amber-500 focus:ring-amber-500 py-3.5 px-4 border transition-colors" placeholder="John" data-id="element-50" />
                </div>
                <div data-id="element-51">
                  <label htmlFor="last-name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-52">
                    Last Name
                  </label>
                  <input type="text" name="last-name" id="last-name" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-amber-500 focus:ring-amber-500 py-3.5 px-4 border transition-colors" placeholder="Doe" data-id="element-53" />
                </div>
              </div>
              <div className="mb-8" data-id="element-54">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-55">
                  Email Address
                </label>
                <input type="email" name="email" id="email" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-amber-500 focus:ring-amber-500 py-3.5 px-4 border transition-colors" placeholder="john@company.com" data-id="element-56" />
              </div>
              <div className="mb-8" data-id="element-57">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-58">
                  Phone Number
                </label>
                <input type="tel" name="phone" id="phone" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-amber-500 focus:ring-amber-500 py-3.5 px-4 border transition-colors" placeholder="+1 (555) 123-4567" data-id="element-59" />
              </div>
              <div className="mb-8" data-id="element-60">
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-61">
                  Company Name
                </label>
                <input type="text" name="company" id="company" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-amber-500 focus:ring-amber-500 py-3.5 px-4 border transition-colors" placeholder="Your Company, Inc." data-id="element-62" />
              </div>
              <div className="mb-8" data-id="element-63">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-64">
                  Message
                </label>
                <textarea id="message" name="message" rows={4} className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-amber-500 focus:ring-amber-500 py-3.5 px-4 border transition-colors" placeholder="Tell us about your lead generation needs..." data-id="element-65" />
              </div>
              <div data-id="element-66">
                <button type="submit" className="w-full py-4 px-4 bg-gradient-to-r from-amber-400 to-red-400 hover:from-amber-500 hover:to-red-500 text-white font-medium rounded-lg shadow-lg transition-all duration-300 hover:shadow-amber-500/20" data-id="element-67">
                  Schedule Free Consultation
                </button>
              </div>
            </form>
          </div>
          <div className="lg:col-span-2" data-id="element-68">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-10 text-white h-full relative overflow-hidden" data-id="element-69">
              {/* Decorative elements */}
              <div className="absolute top-0 left-0 w-full h-full overflow-hidden" data-id="element-70">
                <div className="absolute top-10 left-10 w-40 h-40 bg-amber-400/10 rounded-full blur-3xl" data-id="element-71"></div>
                <div className="absolute bottom-10 right-10 w-60 h-60 bg-red-400/10 rounded-full blur-3xl" data-id="element-72"></div>
              </div>
              <div className="relative z-10" data-id="element-73">
                <h3 className="text-xl font-bold text-white mb-10" data-id="element-74">
                  Why Work With Us
                </h3>
                <div className="space-y-6 mb-12" data-id="element-75">
                  {['Customized lead generation strategies tailored to your business', 'Transparent reporting and communication', 'Dedicated account manager for your campaigns', 'Continuous optimization based on data and performance', 'Proven track record of success across industries', 'No long-term contracts required'].map((item, index) => <div key={index} className="flex items-start" data-id="element-76">
                      <div className="bg-amber-400 rounded-full p-0.5 mr-3 mt-1 flex-shrink-0" data-id="element-77">
                        <CheckIcon className="h-4 w-4 text-gray-900" data-id="element-78" />
                      </div>
                      <span className="text-gray-100" data-id="element-79">{item}</span>
                    </div>)}
                </div>
                <div className="border-t border-white/10 pt-8" data-id="element-80">
                  <h4 className="font-medium text-white mb-6" data-id="element-81">
                    Get in touch directly:
                  </h4>
                  <div className="space-y-5" data-id="element-82">
                    <div className="flex items-center group" data-id="element-83">
                      <div className="bg-white/10 p-3 rounded-full mr-4 group-hover:bg-amber-400/20 transition-colors" data-id="element-84">
                        <PhoneIcon className="h-5 w-5 text-amber-300" data-id="element-85" />
                      </div>
                      <span className="group-hover:text-amber-300 transition-colors" data-id="element-86">
                        +1 (555) 123-4567
                      </span>
                    </div>
                    <div className="flex items-center group" data-id="element-87">
                      <div className="bg-white/10 p-3 rounded-full mr-4 group-hover:bg-amber-400/20 transition-colors" data-id="element-88">
                        <MailIcon className="h-5 w-5 text-amber-300" data-id="element-89" />
                      </div>
                      <span className="group-hover:text-amber-300 transition-colors" data-id="element-90">
                        info@otterreach.co
                      </span>
                    </div>
                    <div className="flex items-center group" data-id="element-91">
                      <div className="bg-white/10 p-3 rounded-full mr-4 group-hover:bg-amber-400/20 transition-colors" data-id="element-92">
                        <MapPinIcon className="h-5 w-5 text-amber-300" data-id="element-93" />
                      </div>
                      <span className="group-hover:text-amber-300 transition-colors" data-id="element-94">
                        123 Business Ave, Suite 200, New York, NY 10001
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}